<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs headline="Bộ môn" :link="[{ text: 'Bộ môn', href: '../academics' }]" />
      </div>
      <div class="d-flex">
        <div class="flex-center" v-if="$auth.policies['add-new-subjectGroup']">
          <v-btn elevation="0" @click="() => openDialog('create')" dark color="#0D47A1">
            <v-icon left>add</v-icon>Thêm Bộ môn</v-btn
          >
        </div>
      </div>
    </div>
    <AcademicLevelTable></AcademicLevelTable>
    <PopupAcademicLevel ref="popup-academic-level" />
  </div>
</template>
<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import AcademicLevelTable from '@/modules/academicLevel/AcademicLevelTable.vue'
import PopupAcademicLevel from '../../modules/academicLevel/PopupAcademicLevel.vue'

export default {
  components: {
    Breadcrumbs,
    PopupAcademicLevel,
    AcademicLevelTable,
  },
  props: {
    role: String,
  },
  data() {
    return {}
  },

  computed: {},
  async created() {},
  methods: {
    openDialog(type) {
      this.$refs['popup-academic-level'].openDialog(type)
    },
  },
}
</script>

<style scoped></style>
